import script from "./RateSect.vue?vue&type=script&setup=true&lang=js"
export * from "./RateSect.vue?vue&type=script&setup=true&lang=js"

import "./RateSect.vue?vue&type=style&index=0&id=6319f9d8&lang=scss"

const __exports__ = script;

export default __exports__